import { reset, SubmissionError } from 'redux-form';
import http from '../../../shared/http';
import endpoints from '../../../../config/endpoints';
import { actions as parentActions } from '../../index';

const defaultInitialState = {
	isShow: false,
	initialValues: null
};

const createForm = ({ namespace, stateNodeName, formName }) => {
	const TOGGLE_FORM = `${namespace}/${stateNodeName}-toggle-form`;
	const FORM_SUBMIT_SUCCESS = `${namespace}/${stateNodeName}-submit-success`;
	const FORM_SUBMIT_ERROR = `${namespace}/${stateNodeName}-submit-error`;

	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = {
		protectionFormSubmit: formData => (dispatch, getState) => {
			if (!formData.code) {
				throw new SubmissionError({code: 'protection code is required'});
			}
			const data = {
				id: formData.id,
				code: formData.code
			};

			const request = http({
				url: endpoints.WM.PROTECTION,
				method: 'post',
				actions: [FORM_SUBMIT_SUCCESS, FORM_SUBMIT_ERROR],
				data
			});

			return request(dispatch).then(action => {
				if (action.type === FORM_SUBMIT_SUCCESS) {
					dispatch(parentActions.fetchData());
				}

				if (action.type === FORM_SUBMIT_ERROR) {
					alert(action.payload.response.data);
				}
			});
		},

		toggleProtectionForm: (initValues) => dispatch => {
			dispatch(reset(formName));
			dispatch({ type: TOGGLE_FORM, payload: {data: initValues} });
		}
	};

	// reducers
	const reducers = {
		[TOGGLE_FORM]: (state, action) => ({
			...state,
			protectionForm: {
				initialValues: state.protectionForm.isShow ? null : (action.payload.data || null),
				isShow: !state.protectionForm.isShow
			}
		}),

		[FORM_SUBMIT_SUCCESS]: state => ({
			...state,
			protectionForm: {
				...state.protectionForm,
				isShow: false
			}
		})
	};

	// selectors
	const selectors = {
		getInitialValues: state => {
			return state[`${namespace}`].protectionForm.initialValues;
		},
		getShouldShowProtectionForm: state => state[`${namespace}`].protectionForm.isShow
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createForm;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/wm/components/protection-form/index.js